import React from 'react'
import Accordion from"./Accordion"
export default function PublicationHeader() {
  return (
    <div><Accordion/></div>
  )
}
